import { LuArrowUpRight } from 'react-icons/lu'
import { MCP_ENDPOINT, CHATGPT_URL, CLAUDE_URL } from '../constants'
import IconCopyButton from './IconCopyButton'
import DialogContent from '@mui/material/DialogContent'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Modal from './Modal'
import { useModalClose } from '../hooks/useModalClose'

type Props = {
  inline?: boolean
}

export default function ModalLLM({ inline }: Readonly<Props>) {
  const { open, handleClose } = useModalClose('/', inline)

  const handleClaude = () => {
    window.open(CLAUDE_URL, '_blank', 'noreferrer')
  }

  const handleChatGPT = () => {
    window.open(CHATGPT_URL, '_blank', 'noreferrer')
  }

  return (
    <Modal open={open} inline={inline} maxWidth="sm" onClose={inline ? undefined : handleClose} color="primary.main">
      <DialogContent>
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
            marginBottom: 1
          }}>
          Choose your language model
        </Typography>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          sx={{
            gap: 2,
            marginBottom: 4
          }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleClaude}
            startIcon={<img src="/claude-white.svg" width={18} height={18} />}
            endIcon={<LuArrowUpRight size={20} />}
            fullWidth
            sx={{
              justifyContent: 'flex-start',
              '& .MuiButton-endIcon': { marginLeft: 'auto' },
            }}
          >
            Claude
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleChatGPT}
            startIcon={<img src="/openai-white.svg" width={18} height={18} />}
            endIcon={<LuArrowUpRight size={20} />}
            fullWidth
            sx={{
              justifyContent: 'flex-start',
              '& .MuiButton-endIcon': { marginLeft: 'auto' },
            }}
          >
            ChatGPT
          </Button>
        </Stack>
        <TextField
          fullWidth
          label="or install our MCP directly"
          value={MCP_ENDPOINT}
          size="small"
          slotProps={{
            input: {
              readOnly: true,
              endAdornment: <IconCopyButton value={MCP_ENDPOINT} />,
            },
          }}
          sx={{ marginBottom: 1 }}
        />
      </DialogContent>
    </Modal>
  )
}
